import { v4 as uuid } from "uuid";
import { actionTypes } from "./actions";

const appendToast = (message, duration, state, style) => {
    return [...state, { message, duration, style, uuid: uuid() }];
};

export default function (state = [], action) {
    switch (action.type) {
        case actionTypes.TOAST_ERROR: {
            const { message, duration } = action.payload;
            return appendToast(message, duration, state, "error");
        }
        case actionTypes.TOAST_INFO: {
            const { message, duration } = action.payload;
            return appendToast(message, duration, state, "info");
        }
        case actionTypes.TOAST_MESSAGE: {
            const { message, style } = action.payload;
            return appendToast(message, undefined, state, style);
        }
        case actionTypes.TOAST_REMOVE: {
            return (state = []);
        }
        case actionTypes.TOAST_SUCCESS: {
            const { message, duration } = action.payload;
            return appendToast(message, duration, state, "success");
        }
        case actionTypes.TOAST_WARNING: {
            const { message, duration } = action.payload;
            return appendToast(message, duration, state, "warning");
        }
        default: {
            return state;
        }
    }
}
